import { render, staticRenderFns } from "./EmbedVirtualTour.vue?vue&type=template&id=64454fa0&"
import script from "./EmbedVirtualTour.vue?vue&type=script&lang=js&"
export * from "./EmbedVirtualTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports